import { api } from "./api";

export function getVisitorId() {
  let id = localStorage.getItem("s3d_visitor_id");
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : `v${Date.now()}${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("s3d_visitor_id", id);
  }
  return id;
}

let _lastKey = null;
let _lastAt = 0;
export function trackView(path) {
  const now = Date.now();
  if (path === _lastKey && now - _lastAt < 2000) return; // dedupe StrictMode/reload double-fire
  _lastKey = path;
  _lastAt = now;
  try {
    api.post("/analytics/track", {
      type: "view",
      path,
      referrer: document.referrer || "",
      visitor_id: getVisitorId(),
    }).catch(() => {});
  } catch {}
}

export function trackInstall() {
  try {
    api.post("/analytics/track", {
      type: "install",
      path: window.location.pathname,
      referrer: document.referrer || "",
      visitor_id: getVisitorId(),
    }).catch(() => {});
  } catch {}
}
